import { Theme } from 'enums';

export const websiteBottomBannerMap = {
  [Theme.Default]: {
    title: 'plans_page.business_banner_title',
    content: 'plans_page.business_banner_subtitle',
    ctaText: 'plans_page.business_banner_textlink',
  },
  [Theme.AdvancedPlans]: {
    title: 'Advanced.Plans_Enterprise_section_title',
    content: 'Advanced.Plans_Enterprise_section_subheader',
    ctaText: 'Advanced.Plans_Enterprise_section_textlink',
  },
  [Theme.EditorX]: {
    title: 'Advanced.Plans_editorx_Enterprise_section_title',
    content: 'Advanced.Plans_editorx_Enterprise_section_subheader',
    ctaText: 'Advanced.Plans_Enterprise_section_textlink',
  },
};

// TODO: with new keys
export const enterpriseBottomBannerMap = {
  [Theme.Default]: {
    title: 'Advanced.Plans_Enterprise_section_title',
    content: 'Advanced.Plans_Enterprise_section_subheader',
    ctaText: 'Advanced.Plans_Enterprise_section_textlink',
  },
  [Theme.AdvancedPlans]: {
    title: 'Advanced.Plans_Enterprise_section_title',
    content: 'Advanced.Plans_Enterprise_section_subheader',
    ctaText: 'Advanced.Plans_Enterprise_section_textlink',
  },
  [Theme.EditorX]: {
    title: 'Advanced.Plans_editorx_Enterprise_section_title',
    content: 'Advanced.Plans_editorx_Enterprise_section_subheader',
    ctaText: 'Advanced.Plans_Enterprise_section_textlink',
  },
};
